import { Eye, EyeOff } from "lucide-react";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line import/prefer-default-export
export var passwordProps = {
  "true": {
    tooltipContent: "Hide Password",
    icon: /*#__PURE__*/_jsx(Eye, {}),
    type: "text"
  },
  "false": {
    tooltipContent: "Show Password",
    icon: /*#__PURE__*/_jsx(EyeOff, {}),
    type: "password"
  }
};